import { render, staticRenderFns } from "./flexSubHeader.vue?vue&type=template&id=4a7bc17c&"
import script from "./flexSubHeader.vue?vue&type=script&lang=js&"
export * from "./flexSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./flexSubHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "flexSubHeader.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {
  VFlex,
})
